import {
  Component,
  OnDestroy,
  OnInit,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import {MatSelectChange} from '@angular/material/select';
import {Subscription} from 'rxjs';
import {ToolsService} from '../../../../services/tools.service';
import {BookingStaffMember} from '../../types/booking-staff-member';
import {BookingV2StateService} from '../../services/booking-v2-state.service';
import {BookingV2DataService} from '../../services/booking-v2-data.service';
import {BookingV2ManagerService} from '../../services/booking-v2-manager.service';
import {BookingServiceDetail} from '../../../../types/BookingServiceDetail';
import {BookingState} from '../../types/booking-state';

@Component({
  selector: 'app-calendar-section-v2',
  templateUrl: './calendar-section-v2.component.html',
  styleUrls: ['./calendar-section-v2.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class CalendarSectionV2Component implements OnInit, OnDestroy {
  public staffMembers: Array<BookingStaffMember>;
  public selectedStaffMemberId: string;

  @ViewChild('staffSelect') staffSelect;
  private subscriptions: Subscription[] = [];

  constructor(
    private tools: ToolsService,
    private bookingState: BookingV2StateService,
    private bookingData: BookingV2DataService,
    private bookingManager: BookingV2ManagerService
  ) {
    this.setListeners();
  }

  public ngOnInit(): void {}

  public ngOnDestroy() {
    this.subscriptions.forEach((sub: Subscription) => sub.unsubscribe());
  }

  public handleStuffChange(event: MatSelectChange): void {
    const selectedStaffMember: BookingStaffMember =
      this.bookingData.getStaffMemberById(event.value);
    if (!this.tools.isNil(selectedStaffMember)) {
      this.bookingManager.selectStaffMember(selectedStaffMember);
    }
  }

  public trackByMethod(
    i: number,
    el: BookingStaffMember | BookingServiceDetail
  ) {
    return el ? el.id : null;
  }

  public handleStaffSelectClick(event: boolean): void {
    if (event === true) {
      this.triggerStaffSelectClick();
    }
  }

  private triggerStaffSelectClick(): void {
    this.staffSelect.open();
  }

  private handleState(state: BookingState): void {
    this.selectedStaffMemberId = state.selectedStaffMemberId;
  }

  private setListeners(): void {
    this.subscriptions.push(
      this.bookingData.staffMembers$.subscribe((result) => {
        if (result !== null) {
          this.staffMembers = result;
        }
      }),
      this.bookingState.state$.subscribe((result) => this.handleState(result))
    );
  }
}
